import _objectSpread from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-74d7a7ef"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "signup-page"
};
import { useMatomo } from '@shining3d/matomo';
import { XLSignup as xlSignUp } from '@shining3d/xl-login';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useLang } from '../../hooks/lang';
export default {
  setup: function setup(__props) {
    var _useLang = useLang(),
      $t = _useLang.$t;
    var matomo = useMatomo();
    var store = useStore();
    var router = useRouter();
    var route = useRoute();
    var isSoftwareSide = ref(false);
    var qwebChannelContext = null;
    var showReturnBtn = ref(true); // 是否展示区登录按钮
    var signString = ref('');
    function signUpFeedback(resp) {
      var _resp$result = resp.result,
        username = _resp$result.username,
        password = _resp$result.password,
        phoneArea = _resp$result.phoneArea;
      if (isSoftwareSide.value) {
        matomo.log('click', '软件端|注册|注册成功', '用户在软件端注册成功');
        // 软件端点击下一步则前往完善信息
        router.push({
          path: '/sisu',
          query: {
            username: username,
            password: password,
            phoneArea: phoneArea,
            isSoftware: true
          }
        });
      } else {
        // console.log( '注册反馈=', username, password, phoneArea );
        router.push({
          name: 'SignupSuccess',
          params: Object.assign({
            username: username,
            phoneArea: phoneArea
          }, route.query)
        });
      }
    }
    function readAgreement(params) {
      switch (params) {
        case 'privacyPolicy':
          store.commit('setPrivacyPolicy');
          break;
        case 'termsOfUse':
          store.commit('setTermsOfUse');
          break;
        default:
          break;
      }
      // if ( name === 'privacyPolicy' ){
      // privacyPolicyChange();// 隐私政策
      // }
    }
    function toLogin() {
      var currentQuery = route.query; // 获取当前页面的所有 query 参数
      if (currentQuery.redirectUri) {
        router.push({
          path: '/login',
          query: _objectSpread({}, currentQuery)
        }); // 携带当前页面的 query 参数跳转到注册页面
      } else {
        router.push('/login');
      }
    }
    onMounted(function () {
      // 判断query是否包含产品线，若包含则为软件端
      if (route.query.productLine && route.query.productLine !== 'soliedge') {
        console.log('query包含 产品线');
        showReturnBtn.value = false;
        isSoftwareSide.value = true;
        var homel = document.getElementsByClassName('home-l')[0];
        var footer = document.getElementsByClassName('footer')[0];
        if (homel) {
          homel.style.display = 'none';
        }
        if (footer) {
          footer.style.display = 'none';
        }
      }
      loadQwebchannel();
    });

    // 加载软件端qwebchannel
    function loadQwebchannel() {
      var qChannel = require('@/assets/js/qwebchannel.js');
      if (typeof qt !== 'undefined') {
        // eslint-disable-next-line
        qChannel.QWebChannel(qt.webChannelTransport, genQwebChannelInitFunc());
      }
    }
    function genQwebChannelInitFunc() {
      return function (channel) {
        qwebChannelContext = channel.objects.context;
        if (qwebChannelContext) {
          showReturnBtn.value = false;
          isSoftwareSide.value = true;
          sessionStorage.setItem('ISQTSTYLE_TYPE', '1');
          var homel = document.getElementsByClassName('home-l')[0];
          var footer = document.getElementsByClassName('footer')[0];
          if (homel) {
            homel.style.display = 'none';
          }
          if (footer) {
            footer.style.display = 'none';
          }

          // eslint-disable-next-line no-undef
          qwebChannelContext.onMsg('info', 'init success!');
        }
        if (channel.objects.odmEnable) {
          signString.value = 'dental';
        }
      };
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(xlSignUp), {
        "product-key": "passport",
        onToLogin: toLogin,
        onReadAgreement: readAgreement,
        onSignUpFeedback: signUpFeedback,
        "hide-to-login": !showReturnBtn.value,
        sign: signString.value,
        "is-software": isSoftwareSide.value,
        isMarketMailSubscribed: true,
        "signup-button-text": isSoftwareSide.value ? _unref($t)('registerText') : _unref($t)('registerText')
      }, null, 8, ["hide-to-login", "sign", "is-software", "signup-button-text"])]);
    };
  }
};